/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OtpRequest
 */
export interface OtpRequest {
    /**
     * 
     * @type {string}
     * @memberof OtpRequest
     */
    tempOtpToken: string;
    /**
     * 
     * @type {string}
     * @memberof OtpRequest
     */
    otp: string;
}

/**
 * Check if a given object implements the OtpRequest interface.
 */
export function instanceOfOtpRequest(value: object): value is OtpRequest {
    if (!('tempOtpToken' in value) || value['tempOtpToken'] === undefined) return false;
    if (!('otp' in value) || value['otp'] === undefined) return false;
    return true;
}

export function OtpRequestFromJSON(json: any): OtpRequest {
    return OtpRequestFromJSONTyped(json, false);
}

export function OtpRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OtpRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'tempOtpToken': json['temp_otp_token'],
        'otp': json['otp'],
    };
}

  export function OtpRequestToJSON(json: any): OtpRequest {
      return OtpRequestToJSONTyped(json, false);
  }

  export function OtpRequestToJSONTyped(value?: OtpRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'temp_otp_token': value['tempOtpToken'],
        'otp': value['otp'],
    };
}

